import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/humo.png'
import _imports_1 from '@/assets/uzcard.png'


const _withScopeId = n => (_pushScopeId("data-v-1e0435ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__payments" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Humo logo",
    class: "payment-logo"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "UzCard logo",
    class: "payment-logo"
  })
], -1))
const _hoisted_4 = { class: "footer__contact" }
const _hoisted_5 = {
  href: "https://t.me/TenderAsiaSupport",
  target: "_blank",
  class: "btn btn-gray"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-telegram" }, null, -1))
const _hoisted_7 = {
  href: "mailto:info@tender.asia",
  class: "btn btn-gray btn--w-icon"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-mail" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass({ 'inner-footer': _ctx.isInner })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'container': !_ctx.isInner, 'wide-footer': _ctx.isInner })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/user_agreement",
            onClick: _ctx.scrollToTop
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("user_agreement.footer")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/privacy_and_terms",
            onClick: _ctx.scrollToTop
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("privacy_and_terms.footer")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/offer",
            onClick: _ctx.scrollToTop
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("offer.footer")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/collections",
            onClick: _ctx.scrollToTop
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("collections.header")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/companies?page=1",
            onClick: _ctx.scrollToTop
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("collections.header_companies")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact_telegram")), 1)
          ]),
          _createElementVNode("a", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact_email")), 1)
          ])
        ])
      ])
    ], 2)
  ], 2))
}